import { render, staticRenderFns } from "./DonutChart34Template.vue?vue&type=template&id=5d6b772d&scoped=true"
import script from "./DonutChart34Template.vue?vue&type=script&lang=js"
export * from "./DonutChart34Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6b772d",
  null
  
)

export default component.exports